import React, { useState, useRef, useEffect  } from 'react'
import { get } from '../Services/http'
import { translate } from '../Services/translation'
import { connect } from 'react-redux';
import { add as addToCart } from '../Actions/Cart.action'

import BuyButton from './BuyButton'
import Selectbox from './Selectbox'
import Loader from './Loader'

import { tcEventProductListView, tcEventProductClickEvent, tcEventClickSortEvent } from '../Actions/TagCommander.action'
import ProductCard from './ProductCard';
import ArticleCard from './ArticleCard';

// Add to cart - prop comes from mapDispatchToProps (store)
const CategoryProductList = (({ categorySystemId, blockSystemId, title, sortOptions, isMainTitle, numberOfProducts, addToCart }) => {
    const defaultNumberOfProducts = 8
    const [cards, setCards] = useState([])
    const [tagCommanderProducts, setTagCommanderProducts] = useState({})
    const [loading, setLoading] = useState(true)
    const [pageNumber, setPageNumber] = useState(0)
    const [pageSize] = useState(() => {
        if (numberOfProducts > 0) return numberOfProducts
        return defaultNumberOfProducts
    })
    const [totalCount, setTotalCount] = useState(0)
    const parsedSortOptions = JSON.parse(sortOptions) 
    const [sortBy, setSortBy] = useState(parsedSortOptions[0].value)
    const [sortByOptions] = useState(parsedSortOptions);

    // Fetch products when page changes, sort changes, or on first load
    useEffect(() => {
        const params = new URLSearchParams({
            productListTitle: title,
            categorySystemId,
            blockSystemId,
            pageNumber,
            pageSize,
            sortBy,
        });
        
        setLoading(true);
        get(`/api/block/getcategoryproducts?${params.toString()}`)
            .then(response => response.json())
            .then(result => {
                result.cards && setCards([...result.cards]);
                result.pagination && setTotalCount(result.pagination.totalCount);
                result.tagCommanderProducts && setTagCommanderProducts(result.tagCommanderProducts);
            })
            .catch(error => {
                console.warn(error);
            })
            .finally(() => {
                setLoading(false);
            });
    
    }, [pageNumber, sortBy] || []);

    // Call tcEventProductListView when we update displayed products
    useEffect(() => {
        if(tagCommanderProducts.productList == null)
            return
        if(tagCommanderProducts.productList.length == 0)
            return
        
        tcEventProductListView(tagCommanderProducts)
    }, [tagCommanderProducts])

    const handleSortOrder = (eventOrObjectValue) => {
        eventOrObjectValue = eventOrObjectValue.value || eventOrObjectValue.target.value || null
        
        if (eventOrObjectValue == null) return

        setSortBy(eventOrObjectValue)
        tcEventClickSortEvent(eventOrObjectValue)
    }

    return (
        <>
            <ProductListHeaderComponent {...{ title, isMainTitle, handleSortOrder, sortByOptions, sortBy }}  />

            <List {...{ cards, addToCart, title }} />
        
            <LoadMore {...{ loading, cards, totalCount, setPageNumber, pageNumber }} /> 

            <Loader {...{ loading }} />
        </>
    )
})

const ProductListHeaderComponent = ({ title, isMainTitle, handleSortOrder, sortByOptions, sortBy }) => {
    return isMainTitle ? (
            <div className="product-list__heading product-list__heading--sortable aos-init aos-animate">
                <h1>
                    { title }
                </h1>

                <Selectbox {...{ 
                    onChange: (e, newSortOrder) => handleSortOrder(e), 
                    options: sortByOptions, 
                    selectedOption: sortBy,
                    placeHolder: translate('facet.header.sortcriteria'),
                    className: 'selectbox selectbox--heading',
                    align: 'right' }}/>
            </div>
        ) : (
            <div className="product-list__heading product-list__heading--sortable aos-init aos-animate">
                <h2>
                    { title }
                </h2>

                <Selectbox {...{ 
                    onChange: (e, newSortOrder) => handleSortOrder(e), 
                    options: sortByOptions, 
                    selectedOption: sortBy, 
                    placeHolder: translate('facet.header.sortcriteria'),
                    className: 'selectbox selectbox--heading',
                    align: 'right' }}/>
            </div>
        )
}

const List = ({cards, addToCart, title }) => {
    return (
        <div className="product-list__items">
            {cards.map((card, index) => 
                <div className="product-list__item" key={index}>
                    {
                        card.id != null 
                            ? <ProductCard {...{ 
                                product: card, 
                                theme: null, 
                                addToCart, 
                                onClick: (product) => tcEventProductClickEvent(card, title, index) 
                            }} />
                            : <ArticleCard {...{ 
                                title: card.title, 
                                text: card.text.value, 
                                theme: card.themeString,
                                imageSrc: card.imageSrc, 
                                webTagSrc: card.webTagSrc, 
                                linkUrl: card.linkUrl, 
                                linkText: card.linkText
                            }} />
                    }
                </div>
            )}
        </div>
    )
}

const LoadMore = ({ loading, cards, totalCount, setPageNumber, pageNumber }) => {
    let shouldShow = true
    if (cards.length >= totalCount) shouldShow = false
    if (loading) shouldShow = false
    return shouldShow && (
        <div className='product-list-more'>
            <button className='button button--green' onClick={() => setPageNumber(pageNumber + 1) }>
                { translate('filter.showmore') }
            </button>
        </div>
    )
}

const mapDispatchToProps = dispatch => {
    return {
        addToCart: (buttonDomNode, articleNumber) => {
            dispatch(addToCart({ 
                articleNumber, 
                quantity: 1,
                hash: Date.now(),
            }));
        }
    }
}

export default connect(null, mapDispatchToProps)(CategoryProductList);